<script setup lang = "ts">

const currentSlide = ref(0)
const slideTo = (val: number) => {
	currentSlide.value = val
}

const move = (val: number) => {
	currentSlide.value += val
}

defineProps<{
	images: Array<string | File> | undefined,
	hasButtons?: boolean,
	removeThumbnails?: boolean,
}>()

const getImage = (image: string) => {
	if (image.includes('http')) {
		return image
	} else {
		return `https://cdn.compralovendelo.com/${image}`
	}
}

</script>
<template>
	<div class = "container-carousel relative">
		<Carousel id = "gallery" :items-to-show = "1" :wrap-around = "false" v-model = "currentSlide">
			<Slide v-for = "(slide,item) in images" :key = "item">
				<div class = "carousel__item h-[250px] sm:h-[300px] md:h-[350px] xl:h-[60vh] w-full"
						 :style = "{backgroundImage:`url(${getImage(slide.toString())})`}"/>
			</Slide>
		</Carousel>
		
		<div v-if = "!!hasButtons"
				 class = "content-moved flex flex-row justify-between absolute w-full h-[40px] p-5 items-center"
				 style = "top:calc(50% - 20px)">
			<div :class = "`drop-shadow prevBtn cursor-pointer text-white`"
					 @click = "move(-1)">
				<i class = "text-[30px] fa-solid fa-chevron-circle-left"/>
			</div>
			<div
					:class = "`drop-shadow nextBtn cursor-pointer text-white`"
					@click = "move(1)">
				<i class = "text-[30px] fa-solid fa-chevron-circle-right"/>
			</div>
		</div>
	</div>
	
	<Carousel
			id = "thumbnails"
			class = "pt-5"
			:items-to-show = "4"
			:wrap-around = "true"
			v-model = "currentSlide"
			ref = "carousel"
			v-if = "!removeThumbnails"
	>
		<Slide v-for = "(slide,item) in images" :key = "item">
			<div class = "carousel__item w-[100px] aspect-video mx-1"
					 @click = "slideTo(item )"
					 :style = "{backgroundImage:`url(${getImage(slide.toString())})`}"/>
		</Slide>
	</Carousel>
</template>

<style>
.carousel#thumbnails .carousel__item {
	background-position: center !important;
	background-repeat: no-repeat !important;
	background-size: cover !important;
	width: 100% !important;
}

.carousel#gallery .carousel__item {
	background-position: center !important;
	background-repeat: no-repeat !important;
	background-size: cover !important;
	width: 100% !important;
	background-color: white !important;
}
</style>